import React from 'react'
import type { DrawerProps } from '@/ui/components'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerTitle,
} from '@/ui/components'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, csx, Text } from '@vtex/admin-ui'

type AddToCartSectionWithoutStockDrawerProps = DrawerProps & {
  handleAddToCart: () => void
}

export const AddToCartSectionWithoutStockDrawer = ({
  handleAddToCart,
  ...props
}: AddToCartSectionWithoutStockDrawerProps) => {
  const { formatMessage } = useIntl()

  return (
    <Drawer {...props} data-testid="add-to-cart-without-stock-drawer">
      <DrawerTitle>
        {formatMessage({
          id: 'checkout.add-to-cart.without-stock.drawer.title',
        })}
      </DrawerTitle>
      <DrawerCloseButton />
      <DrawerBody>
        <Text variant="action2" tone="secondary">
          <FormattedMessage id="checkout.add-to-cart.without-stock.drawer.body" />
        </Text>
      </DrawerBody>
      <DrawerFooter>
        <Button
          size="large"
          className={csx({ width: '100%', marginBottom: '$space-2' })}
          onClick={handleAddToCart}
        >
          <FormattedMessage id="add-to-cart" />
        </Button>
        <Button
          size="large"
          className={csx({ width: '100%' })}
          variant="secondary"
          onClick={() => props.onClose()}
        >
          <FormattedMessage id="cancel" />
        </Button>
      </DrawerFooter>
    </Drawer>
  )
}
